export type LeadAssignmentRuleFormProps = {
  open: boolean
  onClose: () => void
  editValues?: LeadAssignmentRuleFormModel
  /**
   * Whether this is an existing rule, when that cannot be read from `editValues`.
   *
   * It normally can -- values mean an edit -- but a NEW rule resumed after its author went to
   * the map to draw a territory (WWM-17508) also arrives with values, and calling that screen
   * "Edit Assignment Rule" would be a lie about what Save is going to do.
   */
  isEdit?: boolean
}

export type LeadAttribute =
  | 'ZipCode'
  | 'Branch'
  | 'Campaign'
  | 'LeadSource'
  | 'Division'
  | 'CreatedBy'
  | 'LocationType'
  | 'State'
  | 'StateAll'
  | 'TargetPest'
  | 'LeadType'
  // A D2D sales territory containing the lead's location (WWM-17508). Unlike the others this is
  // not a field on the lead -- the server derives it from the lead's coordinates.
  | 'Territory'
  | ''

export type MatchType = 'Any' | 'None'

export type ConditionModel = {
  id?: number
  attribute: LeadAttribute
  matchType: MatchType
  assignmentRuleConditionValues: string[] | any[]
  order?: number
}

export type LeadAssignmentRuleFormModel = {
  id?: number
  name: string
  description: string
  assignmentRuleConditions: ConditionModel[]
  salesTeamIds: number[]
  ownerIds: string[]
  salesTeamId: string
  ownerId: string | null
  salesFunnelId: string
  leadStatusId: string
  matchType: MatchType
}

export const initialValues: LeadAssignmentRuleFormModel = {
  name: '',
  description: '',
  assignmentRuleConditions: [],
  salesTeamIds: [],
  ownerIds: [],
  salesTeamId: '',
  ownerId: '',

  salesFunnelId: '',
  leadStatusId: '',

  matchType: 'Any',
}

export type LeadAssignmentRule = Omit<
  LeadAssignmentRuleFormModel,
  'matchType'
> & {
  automatedAssignmentId: number
  approvedSalesTeamIds: number[]
  approvedOwnerIds: string[]
  /** True when these approvals came from a D2D territory rather than an assignment rule. */
  isTerritoryDerived?: boolean
  allOwnerIds: string[]
  /**
   * Every sales team in the tenant, not only the rule's own (SearchAssignmentRuleDTO
   * .AllSalesTeamIds). The server has always sent it; it is typed here because OwnerSelect needs
   * it to resolve an eligible owner who belongs to a team other than the selected one.
   */
  allSalesTeamIds?: number[]
}
